import { folderIcon }  from '~/assets/icons/js/folderIcon';
export default (editor, opts = {}) => {
  const pns = editor.Panels;

  pns.addButton('options',{
    id: 'btn-step-modal',
    label: `${folderIcon}`,
    command: 'open-step-modal-vue',
    attributes:{
      title: 'Steps manager'
    },
    active: false,
  });
  
}

